export const AUTH_CHALLENGES = {
  CUSTOM_CHALLENGE: 'CUSTOM_CHALLENGE',
};

export const PAYMENT_LINK_STATUSES = {
  EXPIRED: 'EXPIRED', ACTIVE: 'ACTIVE', PAID: 'PAID', CANCELLED: 'CANCELLED', DECLINED: 'DECLINED'
};

export const WOOCOMMERCE_ORDER_STATUSES = {
  CREATED: 'CREATED', OPEN: 'OPEN', IN_PROGRESS: 'IN_PROGRESS', OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY', CLOSED: 'CLOSED', CANCELLED: 'CANCELLED'
};

export const TRANSFER_LINK_STATUSES = {
  EXPIRED: 'EXPIRED', ACTIVE: 'ACTIVE', PAID: 'PAID', CANCELLED: 'CANCELLED', DECLINED: 'DECLINED'
};

export const SETUP_SESSION_STATUSES = {
  VERIFIED: 'VERIFIED'
};

export const SESSION_TIME = {
  REDIRECT_URL: 0,
  NO_REDIRECT_URL: 5000,
  MANUAL_PLAID: 10000
};

export const TAX_STATUS = {
  TAXABLE: 'TAXABLE', EXEMPT: 'EXEMPT'
};

export const GOOGLE_APIKEY = 'AIzaSyCLR2kMaQ9AHIa_tqsG48hxA9CZ7ullXds';

export const MESSAGES = {
  PAYMENT_LINK: {
    EXPIRED: 'The link has expired. This means that your payment has already been processed or your session has expired.',
    ERROR: 'Please try again. If issue persists, contact at support@swirepay.com'
  },
  SETUP_INTENT: {
    ERROR: 'Please try again. If issue persists, contact at support@swirepay.com'
  },
  PARTNER_LINK: {
    EXPIRED: 'The link has expired. This means that your connection has already been processed or your session has expired.',
    ERROR: 'Please try again. If issue persists, contact at support@swirepay.com'
  },
  TRANSFER_LINK: {
    EXPIRED: 'The link has expired. This means that your transfer has already been processed or your session has expired.',
    ERROR: 'Please try again. If issue persists, contact at support@swirepay.com'
  },
  ORUM_VERIFICATION_LINK_STATUS: {
    ERROR: 'Link expired. Re-initiate funding source verification to get a new one.',
    SUCCESS: 'Verification complete. This funding source is already active.'
  },
  ONBOARDING_DOCUMENT_STATUS: {
    SUCCESS: 'The document has already been uploaded for this request.'
  }
};

export const CardNames = {
  VISA: "visa",
  MASTERCARD: "mastercard",
  AMERICAN_EXPRESS: "american-express",
  DINERS_CLUB: "diners-club",
  DISCOVER: "discover",
  JCB: "jcb",
  UNIONPAY: "unionpay",
  MAESTRO: "maestro",
  ELO: "elo",
  MIR: "mir",
  HIPER: "hiper",
  HIPERCARD: "hipercard",
};

export const TabNames = {
  ACH_LEGACY: "ACH_LEGACY",
  CARD: "CARD",
  ACH: "ACH",
  UPI: "UPI",
  WIRE: "WIRE",
  NET_BANKING: "NET_BANKING",
  CREDIT_CARD_NOT_PRESENT: "CREDIT_CARD_NOT_PRESENT",
  DEBIT_CARD_NOT_PRESENT: "DEBIT_CARD_NOT_PRESENT",
  GOOGLE_PAY_US: "GOOGLE_PAY_US",
  APPLE_PAY_US: "APPLE_PAY_US",
  WALLET: "WALLET",
  INSTANT_PAYMENT: "INSTANT_PAYMENT",
  SWIREPAY_US: "SWIREPAY_US",
  CHALLAN: "CHALLAN",
  ZIP_ACH: "ZIP_ACH",
  RAPID_ACH: "RAPID_ACH",
  X_ACH: "X_ACH",
  SAVED_PAYMENT_METHODS: 'SAVED_PAYMENT_METHODS'
};

export const SWIREPAY_URL = 'https://www.swirepay.com';
export const SWIREPAY_SUPPORT_EMAIL = 'support@swirepay.com';
export const SWIREPAY_SUPPORT_PHONE = '408-791-3551';

export const REFRENCE_ID_LENGTH = 14;

export const CARD_NUMBER_LENGTH = {
  "american-express": 15,
  "mastercard": 16,
  "visa": 16,
  "rupay": 16
};

export const CURRENCY_LOCALES = Object.freeze({
  "USD": "en-US",
  "INR": "en-IN"
});

export const VALID_YEAR_MONTH = {
  "MAXYEAR": 2040,
  "TOTALMONTHS": 12,
  "ADDINGYEARS": 2000,
};

export const COUNTRY_PHONE_CODE = Object.freeze(["+1", "+7", "+20", "+27", "+30", "+31", "+32", "+33", "+34", "+36", "+39", "+40", "+41", "+43", "+44", "+45", "+46", "+47", "+48", "+49", "+51", "+52", "+53", "+54",
  "+55", "+56", "+57", "+58", "+60", "+61", "+62", "+63", "+64", "+65", "+66", "+81", "+82", "+84", "+86", "+90", "+91", "+92", "+93", "+94", "+95", "+98", "+211", "+212", "+213", "+216", "+218", "+220",
  "+221", "+222", "+223", "+224", "+225", "+226", "+227", "+228", "+229", "+230", "+231", "+232", "+233", "+234", "+235", "+236", "+237", "+238", "+239", "+240", "+241", "+242", "+243", "+244", "+245",
  "+246", "+248", "+249", "+250", "+251", "+252", "+253", "+254", "+255", "+256", "+257", "+258", "+260", "+261", "+262", "+263", "+264", "+265", "+266", "+267", "+268", "+269", "+290", "+291", "+297",
  "+298", "+299", "+350", "+351", "+352", "+353", "+354", "+355", "+356", "+357", "+358", "+359", "+370", "+371", "+372", "+373", "+374", "+375", "+376", "+377", "+378", "+379", "+380", "+381", "+382",
  "+383", "+385", "+386", "+387", "+389", "+420", "+421", "+423", "+500", "+501", "+502", "+503", "+504", "+505", "+506", "+507", "+508", "+509", "+590", "+591", "+592", "+593", "+595", "+597", "+598",
  "+599", "+670", "+672", "+673", "+674", "+675", "+676", "+677", "+678", "+679", "+680", "+681", "+682", "+683", "+685", "+686", "+687", "+688", "+689", "+690", "+691", "+692", "+850", "+852", "+853",
  "+855", "+856", "+880", "+886", "+960", "+961", "+962", "+963", "+964", "+965", "+966", "+967", "+968", "+970", "+971", "+972", "+973", "+974", "+975", "+976", "+977", "+992", "+993", "+994", "+995",
  "+996", "+998"]);

export const PAYMENT_BUTTON_STATUSES = {
  EXPIRED: 'EXPIRED', ACTIVE: 'ACTIVE', DELETED: 'DELETED', DEACTIVE: 'DEACTIVE'
};

export const ACCOUNT_TYPES = Object.freeze(["CHECKING", "SAVINGS"]);

export const INDIA_ACCOUNT_TYPES = Object.freeze(["CURRENT ACCOUNT", "SAVINGS"]);

export const BUSINESS_TYPES_FUNDINGlINK = Object.freeze(["INDIVIDUAL", "BUSINESS"]);

export const INDIAN_STATES = [{"code": "AN","name": "Andaman and Nicobar Islands"},
  {"code": "AP","name": "Andhra Pradesh"},
  {"code": "AR","name": "Arunachal Pradesh"},
  {"code": "AS","name": "Assam"},
  {"code": "BR","name": "Bihar"},
  {"code": "CG","name": "Chandigarh"},
  {"code": "CH","name": "Chhattisgarh"},
  {"code": "DH","name": "Dadra and Nagar Haveli"},
  {"code": "DD","name": "Daman and Diu"},
  {"code": "DL","name": "Delhi"},
  {"code": "GA","name": "Goa"},
  {"code": "GJ","name": "Gujarat"},
  {"code": "HR","name": "Haryana"},
  {"code": "HP","name": "Himachal Pradesh"},
  {"code": "JK","name": "Jammu and Kashmir"},
  {"code": "JH","name": "Jharkhand"},
  {"code": "KA","name": "Karnataka"},
  {"code": "KL","name": "Kerala"},
  {"code": "LD","name": "Lakshadweep"},
  {"code": "MP","name": "Madhya Pradesh"},
  {"code": "MH","name": "Maharashtra"},
  {"code": "MN","name": "Manipur"},
  {"code": "ML","name": "Meghalaya"},
  {"code": "MZ","name": "Mizoram"},
  {"code": "NL","name": "Nagaland"},
  {"code": "OR","name": "Odisha"},
  {"code": "PY","name": "Puducherry"},
  {"code": "PB","name": "Punjab"},
  {"code": "RJ","name": "Rajasthan"},
  {"code": "SK","name": "Sikkim"},
  {"code": "TN","name": "Tamil Nadu"},
  {"code": "TS","name": "Telangana"},
  {"code": "TR","name": "Tripura"},
  {"code": "UK","name": "Uttarakhand"},
  {"code": "UP","name": "Uttar Pradesh"},
  {"code": "WB","name": "West Bengal"}
  ];

export const SUBSCRIPTION_BUTTON_STATUSES = {
  EXPIRED: 'EXPIRED',
  ACTIVE: 'ACTIVE',
  DEACTIVE: 'DEACTIVE'
};

export const PAYMENT_WIDGET_STATUSES = {
  EXPIRED: 'EXPIRED',
  ACTIVE: 'ACTIVE',
  DEACTIVE: 'DEACTIVE'
};

export const BENETYPES = {
  BANK: 'BANK',
  VPA: 'VPA',
};

export const USA_STATES = [
  { "code": "AL", "name": "Alabama" },
  { "code": "AK", "name": "Alaska" },
  { "code": "AZ", "name": "Arizona" },
  { "code": "AR", "name": "Arkansas" },
  { "code": "CA", "name": "California" },
  { "code": "CO", "name": "Colorado" },
  { "code": "CT", "name": "Connecticut" },
  { "code": "DE", "name": "Delaware" },
  { "code": "FL", "name": "Florida" },
  { "code": "GA", "name": "Georgia" },
  { "code": "HI", "name": "Hawaii" },
  { "code": "ID", "name": "Idaho" },
  { "code": "IL", "name": "Illinois" },
  { "code": "IN", "name": "Indiana" },
  { "code": "IA", "name": "Iowa" },
  { "code": "KS", "name": "Kansas" },
  { "code": "KY", "name": "Kentucky" },
  { "code": "LY", "name": "Louisiana" },
  { "code": "ME", "name": "Maine" },
  { "code": "MD", "name": "Maryland" },
  { "code": "MA", "name": "Massachusetts" },
  { "code": "MI", "name": "Michigan" },
  { "code": "MN", "name": "Minnesota" },
  { "code": "MS", "name": "Mississippi" },
  { "code": "MO", "name": "Missouri" },
  { "code": "MT", "name": "Montana" },
  { "code": "NE", "name": "Nebraska" },
  { "code": "NV", "name": "Nevada" },
  { "code": "NH", "name": "New Hampshire" },
  { "code": "NJ", "name": "New Jersey" },
  { "code": "NM", "name": "New Mexico" },
  { "code": "NY", "name": "New York" },
  { "code": "NC", "name": "North Carolina" },
  { "code": "ND", "name": "North Dakota" },
  { "code": "OH", "name": "Ohio" },
  { "code": "OK", "name": "Oklahoma" },
  { "code": "OR", "name": "Oregon" },
  { "code": "PA", "name": "Pennsylvania" },
  { "code": "RI", "name": "Rhode Island" },
  { "code": "SC", "name": "South Carolina" },
  { "code": "SD", "name": "South Dakota" },
  { "code": "TN", "name": "Tennessee" },
  { "code": "TX", "name": "Texas" },
  { "code": "UT", "name": "Utah" },
  { "code": "VT", "name": "Vermont" },
  { "code": "VA", "name": "Virginia" },
  { "code": "WA", "name": "Washington" },
  { "code": "WV", "name": "West Virginia" },
  { "code": "WI", "name": "Wisconsin" },
  { "code": "WY", "name": "Wyoming" },
];

export const CURRENCY_CODES = Object.freeze(["INR", "USD"]);

export const PAYMENT_METHOD = Object.freeze(["CARD"]);

export const TOKENS = {
  ACCESS_TOKEN: 'access_token',
  SESSION_TOKEN: 'sp_session',
  REFRESH_TOKEN: 'refresh_token',
};

export const EMAIL = {
  DEFAULT_REGEX: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/,
  // eslint-disable-next-line
  PAYMENTPAGE_EMAIL_REGEX: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  DEFAULT_ERROR_MESSAGE: "The email is invalid",
  NEW_EMAIL_REGEX: /^[^%$\/#~]+@[^@]+$/,
  NEW_EMAIL_REGEX1: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};

export const TAX_RATE_TYPES = {
  INCLUSIVE: 'Inclusive',
  EXCLUSIVE: 'Exclusive',
};

export const ECWID_ORDER_STATUS = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
};

export const WOOCOMMERCE_ORDER_STATUS = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
};

export const ECWID_ORDER_STATUS_ERROR = {
  PAID: 'Order already paid',
  CANCELLED: 'Payment was cancelled. Please use any other payment method or try again later.',
};

export const WOOCOMMERCE_ORDER_STATUS_ERROR = {
  PAID: 'Order already paid',
  CANCELLED: 'Payment was cancelled. Please use any other payment method or try again later.',
};

export const SUPPORTED_PAYMENT_TYPES = {
  "CARD": ["CREDIT_CARD_NOT_PRESENT", "DEBIT_CARD_PRESENT", "DEBIT_CARD_NOT_PRESENT", "CREDIT_CARD_PRESENT"],
  "UPI": ["UPI"],
  "ACH": ["ACH"],
  "ACH_LEGACY": ["ACH_LEGACY"]
};

export const PAGES = {
  PAYMENT_WIDGET: '/payment-widget-link',
  PAYMENT_WIDGET_PAY: '/widget-link-pay',
  PAYMENTPAGE_LINK: '/payment-page-link',
  SEATSPAGE_PAY: '/seat-page-link',
  RTP_PAYMENT_LINK: '/rtp-payment-link',
  RTP_ADDED_BANKS: '/rtp-added-banks',
  RTP_LOGIN: '/rtp-login',
  RTP_WALLET_PIN_SETUP: '/rtp-walletpin-setup',
  RTP_BANK_ACCOUNT_SETUP: '/rtp-bank-account-setup',
  RTP_OTP_VERIFICATION: '/rtp-otp-verification',
  RTP_REGISTER: '/rtp-register'
};

export const WIDGET_INTERVALS = [
  { name: 'One-time', value: 'ONETIME' },
  { name: 'Weekly', value: 'WEEK' },
  { name: 'Monthly', value: 'MONTH' },
  { name: 'Yearly', value: 'YEAR' },
];

export const TRANSFERLINK_MESSAGES = {
  HEADER: 'Please Wait!. Your transferLink link decline is being processed',
  BODY: 'You will be redirected when the decline is successful.',
  COMPLETE: 'TransferLink Decline Completed',
  REDIRECT: 'You will be redirected automatically.',
};

export const expireyText = "Payment session will expire in ";

export const ACCOUNT_MDR = {
  MERCHANT: 'MERCHANT_MDR',
  CUSTOMER: 'CUSTOMER_MDR',
};

export const NETBANKING_LIST = [
  {
    "gid": "swirepaynetbanking-7da220b3a0df4286bcd1c412f929852d",
    "bankName": "Allahabad Bank",
    "paymentType": "NET_BANKING_ALLAHABAD_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a595428b51b311ec95d10242ac120002",
    "bankName": "Axis Bank",
    "paymentType": "NET_BANKING_AXIS_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a59e525f51b311ec95d10242ac120002",
    "bankName": "Bank of Baroda - Retail Banking",
    "paymentType": "NET_BANKING_BANK_OF_BARODA_RETAIL_BANKING",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a59e5bc951b311ec95d10242ac120002",
    "bankName": "Bank of India",
    "paymentType": "NET_BANKING_BANK_OF_INDIA",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a59e5e8751b311ec95d10242ac120002",
    "bankName": "Bank of Maharashtra",
    "paymentType": "NET_BANKING_BANK_OF_MAHARASHTRA",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-00f895afc7394ba3a24f18d75730f6b4",
    "bankName": "BNP Paribas",
    "paymentType": "NET_BANKING_BNP_PARIBAS",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a59e611c51b311ec95d10242ac120002",
    "bankName": "Canara Bank",
    "paymentType": "NET_BANKING_CANARA_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a59e64f651b311ec95d10242ac120002",
    "bankName": "Catholic Syrian Bank",
    "paymentType": "NET_BANKING_CATHOLIC_SYRIAN_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a59ff78c51b311ec95d10242ac120002",
    "bankName": "Central Bank of India",
    "paymentType": "NET_BANKING_CENTRAL_BANK_OF_INDIA",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a59ffc8551b311ec95d10242ac120002",
    "bankName": "City Union Bank",
    "paymentType": "NET_BANKING_CITY_UNION_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5a5de2d51b311ec95d10242ac120002",
    "bankName": "Deutsche Bank",
    "paymentType": "NET_BANKING_DEUTSCHE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5a5e29a51b311ec95d10242ac120002",
    "bankName": "DBS Bank Ltd",
    "paymentType": "NET_BANKING_DBS_BANK_LTD",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5a5e54151b311ec95d10242ac120002",
    "bankName": "DCB Bank - Personal",
    "paymentType": "NET_BANKING_DCB_BANK_PERSONAL",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5ab096c51b311ec95d10242ac120002",
    "bankName": "Dhanlakshmi Bank",
    "paymentType": "NET_BANKING_DHANLAKSHMI_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5ab0e3351b311ec95d10242ac120002",
    "bankName": "Federal Bank",
    "paymentType": "NET_BANKING_FEDERAL_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5acaf7f51b311ec95d10242ac120002",
    "bankName": "HDFC Bank",
    "paymentType": "NET_BANKING_HDFC_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5acb3e051b311ec95d10242ac120002",
    "bankName": "ICICI Bank",
    "paymentType": "NET_BANKING_ICICI_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5acb68651b311ec95d10242ac120002",
    "bankName": "IDBI Bank",
    "paymentType": "NET_BANKING_IDBI_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5acb91351b311ec95d10242ac120002",
    "bankName": "IDFC FIRST Bank",
    "paymentType": "NET_BANKING_IDFC_FIRST_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5acbbd651b311ec95d10242ac120002",
    "bankName": "Indian Bank",
    "paymentType": "NET_BANKING_INDIAN_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b5c88851b311ec95d10242ac120002",
    "bankName": "Indian Overseas Bank",
    "paymentType": "NET_BANKING_INDIAN_OVERSEAS_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8a98551b311ec95d10242ac120002",
    "bankName": "IndusInd Bank",
    "paymentType": "NET_BANKING_INDUSIND_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8ae7851b311ec95d10242ac120002",
    "bankName": "Jammu and Kashmir Bank",
    "paymentType": "NET_BANKING_JAMMU_AND_KASHMIR_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8b14951b311ec95d10242ac120002",
    "bankName": "Karnataka Bank Ltd",
    "paymentType": "NET_BANKING_KARNATAKA_BANK_LTD",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8b3ea51b311ec95d10242ac120002",
    "bankName": "Karur Vysya Bank",
    "paymentType": "NET_BANKING_KARUR_VYSYA_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8b6bd51b311ec95d10242ac120002",
    "bankName": "Kotak Mahindra Bank",
    "paymentType": "NET_BANKING_KOTAK_MAHINDRA_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8b99451b311ec95d10242ac120002",
    "bankName": "Laxmi Vilas Bank - Retail Net Banking",
    "paymentType": "NET_BANKING_LAXMI_VILAS_BANK_RETAIL_NET_BANKING",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8bc1751b311ec95d10242ac120002",
    "bankName": "Punjab & Sind Bank",
    "paymentType": "NET_BANKING_PUNJAB_AND_SIND_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8be9351b311ec95d10242ac120002",
    "bankName": "Punjab National Bank - Retail Net Banking",
    "paymentType": "NET_BANKING_PUNJAB_NATIONAL_BANK_RETAIL_NET_BANKING",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8c11b51b311ec95d10242ac120002",
    "bankName": "RBL Bank",
    "paymentType": "NET_BANKING_RBL_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5b8c46051b311ec95d10242ac120002",
    "bankName": "Saraswat Bank",
    "paymentType": "NET_BANKING_SARASWAT_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c30cfa51b311ec95d10242ac120002",
    "bankName": "South Indian Bank",
    "paymentType": "NET_BANKING_SOUTH_INDIAN_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3113b51b311ec95d10242ac120002",
    "bankName": "Standard Chartered Bank",
    "paymentType": "NET_BANKING_STANDARD_CHARTERED_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c313d351b311ec95d10242ac120002",
    "bankName": "State Bank Of India",
    "paymentType": "NET_BANKING_STATE_BANK_OF_INDIA",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3165d51b311ec95d10242ac120002",
    "bankName": "Tamilnad Mercantile Bank Ltd",
    "paymentType": "NET_BANKING_TAMILNAD_MERCANTILE_BANK_LTD",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3194351b311ec95d10242ac120002",
    "bankName": "UCO Bank",
    "paymentType": "NET_BANKING_UCO_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c31d0e51b311ec95d10242ac120002",
    "bankName": "Union Bank of India",
    "paymentType": "NET_BANKING_UNION_BANK_OF_INDIA",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c31faa51b311ec95d10242ac120002",
    "bankName": "Yes Bank Ltd",
    "paymentType": "NET_BANKING_YES_BANK_LTD",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3222b51b311ec95d10242ac120002",
    "bankName": "Bank of Baroda - Corporate",
    "paymentType": "NET_BANKING_BANK_OF_BARODA_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c325e551b311ec95d10242ac120002",
    "bankName": "Bank of India - Corporate",
    "paymentType": "NET_BANKING_BANK_OF_INDIA_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3288451b311ec95d10242ac120002",
    "bankName": "DCB Bank - Corporate",
    "paymentType": "NET_BANKING_DCB_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c32b0e51b311ec95d10242ac120002",
    "bankName": "Lakshmi Vilas Bank - Corporate",
    "paymentType": "NET_BANKING_LAKSHMI_VILAS_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c32d8651b311ec95d10242ac120002",
    "bankName": "Punjab National Bank - Corporate",
    "paymentType": "NET_BANKING_PUNJAB_NATIONAL_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c32ff251b311ec95d10242ac120002",
    "bankName": "State Bank of India - Corporate",
    "paymentType": "NET_BANKING_STATE_BANK_OF_INDIA_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3326051b311ec95d10242ac120002",
    "bankName": "Union Bank of India - Corporate",
    "paymentType": "NET_BANKING_UNION_BANK_OF_INDIA_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-4a55b830d2a14c9b94c503d15b5208d7",
    "bankName": "Vijaya Bank",
    "paymentType": "NET_BANKING_VIJAYA_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3350c51b311ec95d10242ac120002",
    "bankName": "Axis Bank Corporate",
    "paymentType": "NET_BANKING_AXIS_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3378851b311ec95d10242ac120002",
    "bankName": "Dhanlaxmi Bank Corporate",
    "paymentType": "NET_BANKING_DHANLAXMI_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c33a6251b311ec95d10242ac120002",
    "bankName": "ICICI Corporate Netbanking",
    "paymentType": "NET_BANKING_ICICI_CORPORATE_NETBANKING",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c33ccd51b311ec95d10242ac120002",
    "bankName": "Ratnakar Corporate Banking",
    "paymentType": "NET_BANKING_RATNAKAR_CORPORATE_BANKING",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c33f1b51b311ec95d10242ac120002",
    "bankName": "Shamrao Vithal Bank Corporate",
    "paymentType": "NET_BANKING_SHAMRAO_VITHAL_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3410951b311ec95d10242ac120002",
    "bankName": "Equitas Small Finance Bank",
    "paymentType": "NET_BANKING_EQUITAS_SMALL_FINANCE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3437351b311ec95d10242ac120002",
    "bankName": "Yes Bank Corporate",
    "paymentType": "NET_BANKING_YES_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3456b51b311ec95d10242ac120002",
    "bankName": "Bandhan Bank - Corporate banking",
    "paymentType": "NET_BANKING_BANDHAN_BANK_CORPORATE_BANKING",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3475a51b311ec95d10242ac120002",
    "bankName": "Barclays Corporate - Corporate Banking - Corporate",
    "paymentType": "NET_BANKING_BARCLAYS_CORPORATE_CORPORATE_BANKING_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3494651b311ec95d10242ac120002",
    "bankName": "Indian Overseas Bank Corporate",
    "paymentType": "NET_BANKING_INDIAN_OVERSEAS_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c34b3251b311ec95d10242ac120002",
    "bankName": "City Union Bank of Corporate",
    "paymentType": "NET_BANKING_CITY_UNION_BANK_OF_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c34d1a51b311ec95d10242ac120002",
    "bankName": "HDFC Corporate",
    "paymentType": "NET_BANKING_HDFC_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c34f0851b311ec95d10242ac120002",
    "bankName": "Shivalik Bank",
    "paymentType": "NET_BANKING_SHIVALIK_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c350f351b311ec95d10242ac120002",
    "bankName": "AU Small Finance",
    "paymentType": "NET_BANKING_AU_SMALL_FINANCE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c352db51b311ec95d10242ac120002",
    "bankName": "Bandhan Bank - Retail Net Banking",
    "paymentType": "NET_BANKING_BANDHAN_BANK_RETAIL_NET_BANKING",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c354ca51b311ec95d10242ac120002",
    "bankName": "Shamrao Vitthal Co-operative Bank",
    "paymentType": "NET_BANKING_SHAMRAO_VITTHAL_COOPERATIVE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c356b551b311ec95d10242ac120002",
    "bankName": "Tamil Nadu State Co-operative Bank -  Limited",
    "paymentType": "NET_BANKING_TAMIL_NADU_STATE_COOPERATIVE_BANK__LIMITED",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c358a051b311ec95d10242ac120002",
    "bankName": "Utkarsh Small Finance Bank",
    "paymentType": "NET_BANKING_UTKARSH_SMALL_FINANCE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c35a8851b311ec95d10242ac120002",
    "bankName": "The Surat People's Co-operative Bank Limited",
    "paymentType": "NET_BANKING_THE_SURAT_PEOPLE'S_COOPERATIVE_BANK_LIMITED",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c35c7151b311ec95d10242ac120002",
    "bankName": "Gujarat State Co-operative Bank Limited",
    "paymentType": "NET_BANKING_GUJARAT_STATE_COOPERATIVE_BANK_LIMITED",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c35e5751b311ec95d10242ac120002",
    "bankName": "HSBC Retail Netbanking",
    "paymentType": "NET_BANKING_HSBC_RETAIL_NETBANKING",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a5c3607951b311ec95d10242ac120002",
    "bankName": "Test Bank",
    "paymentType": "NET_BANKING_TEST_BANK",
    "category": "NET_BANKING",
    "isTest": true
  },
  {
    "gid": "swirepaynetbanking-2acffc80fb8f11eca1430242ac120002",
    "bankName": "Janata Sahakari Bank",
    "paymentType": "NET_BANKING_JANATA_SAHAKARI_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe9bdf908e511edb4dd0242ac120003",
    "bankName": "Airtel Payments Bank",
    "paymentType": "NET_BANKING_AIRTEL_PAYMENTS_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe1236c08e511edb4dd0242ac120003",
    "bankName": "Andhra Pragathi Grameena Bank",
    "paymentType": "NET_BANKING_ANDHRA_PRAGATHI_GRAMEENA_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe74dd308e511edb4dd0242ac120003",
    "bankName": "Bank Of Bahrain And Kuwait",
    "paymentType": "NET_BANKING_BANK_OF_BAHRAIN_AND_KUWAIT",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe76c5908e511edb4dd0242ac120003",
    "bankName": "Bassein Catholic Bank",
    "paymentType": "NET_BANKING_BASSEIN_CATHOLIC_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe77bf108e511edb4dd0242ac120003",
    "bankName": "Capital Bank",
    "paymentType": "NET_BANKING_CAPITAL_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe78cc008e511edb4dd0242ac120003",
    "bankName": "Cosmos Bank",
    "paymentType": "NET_BANKING_COSMOS_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe79c5908e511edb4dd0242ac120003",
    "bankName": "DIGI Bank",
    "paymentType": "NET_BANKING_DIGI_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe7b18608e511edb4dd0242ac120003",
    "bankName": "ESAF Small Finance Bank",
    "paymentType": "NET_BANKING_ESAF_SMALL_FINANCE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe7ca3008e511edb4dd0242ac120003",
    "bankName": "Fincare Small Finance Bank Ltd.",
    "paymentType": "NET_BANKING_FINCARE_SMALL_FINANCE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe7e0b008e511edb4dd0242ac120003",
    "bankName": "Jana Small Finance Bank",
    "paymentType": "NET_BANKING_JANA_SMALL_FINANCE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe90e9108e511edb4dd0242ac120003",
    "bankName": "Jio Payments Bank",
    "paymentType": "NET_BANKING_JIO_PAYMENTS_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe7f5cf08e511edb4dd0242ac120003",
    "bankName": "Kalupur Cooperative Bank",
    "paymentType": "NET_BANKING_KALUPUR_COOPERATIVE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe809e308e511edb4dd0242ac120003",
    "bankName": "Kalyan Janata Sahakari Bank",
    "paymentType": "NET_BANKING_KALYAN_JANATA_SAHAKARI_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe81f1c08e511edb4dd0242ac120003",
    "bankName": "Karnataka Grameena Vikas Bank",
    "paymentType": "NET_BANKING_KARNATAKA_GRAMEENA_VIKAS_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe8320908e511edb4dd0242ac120003",
    "bankName": "Kerala Gramin Bank",
    "paymentType": "NET_BANKING_KERALA_GRAMIN_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe8471108e511edb4dd0242ac120003",
    "bankName": "Maharashtra Gramin Bank",
    "paymentType": "NET_BANKING_MAHARASHTRA_GRAMIN_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe85a4608e511edb4dd0242ac120003",
    "bankName": "Mehsana Urban Co-Operative Bank",
    "paymentType": "NET_BANKING_MEHSANA_URBAN_CO-OPERATIVE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe86fbb08e511edb4dd0242ac120003",
    "bankName": "NKGSB_BANK",
    "paymentType": "NET_BANKING_NKGSB_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe8845e08e511edb4dd0242ac120003",
    "bankName": "North East Small Bank",
    "paymentType": "NET_BANKING_NOSRTH_EAST_SMALL_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe899f208e511edb4dd0242ac120003",
    "bankName": "Nutan Nagarik Sahakari Bank",
    "paymentType": "NET_BANKING_NUTAN_NAGARIK_SAHAKARI_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe8acc308e511edb4dd0242ac120003",
    "bankName": "Pragathikrishna Bank",
    "paymentType": "NET_BANKING_PRAGATHIKRISHNA_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe8bd9608e511edb4dd0242ac120003",
    "bankName": "Ratnakar Bank",
    "paymentType": "NET_BANKING_RATNAKAR_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe8cf5f08e511edb4dd0242ac120003",
    "bankName": "SBM Bank",
    "paymentType": "NET_BANKING_SBM_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe8e26708e511edb4dd0242ac120003",
    "bankName": "SCB Bank",
    "paymentType": "NET_BANKING_SCB_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe921c608e511edb4dd0242ac120003",
    "bankName": "Suryoday Small Finance Bank",
    "paymentType": "NET_BANKING_SURYODAY_SMALL_FINANCE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe933e808e511edb4dd0242ac120003",
    "bankName": "Sutex Bank",
    "paymentType": "NET_BANKING_SUTEX_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe946c508e511edb4dd0242ac120003",
    "bankName": "Thane Bharath Sahakari Bank",
    "paymentType": "NET_BANKING_THANE_BHARATH_SAHAKARI_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe9587408e511edb4dd0242ac120003",
    "bankName": "The Zoroastrian Co-Operative Bank",
    "paymentType": "NET_BANKING_THE_ZOROASTRIAN_CO-OPERATIVE_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe9678108e511edb4dd0242ac120003",
    "bankName": "TJSB",
    "paymentType": "NET_BANKING_TJSB",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe976e808e511edb4dd0242ac120003",
    "bankName": "UCO Bank Corporate",
    "paymentType": "NET_BANKING_UCO_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe987c608e511edb4dd0242ac120003",
    "bankName": "Ujjvan Bank",
    "paymentType": "NET_BANKING_UJJVAN_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9fe9bbb908e511edb4dd0242ac120003",
    "bankName": "Varachha Bank",
    "paymentType": "NET_BANKING_VARACHHA_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-752c5e6ca61f4124b9be61fef29781e2",
    "bankName": "RBL Bank Corporate",
    "paymentType": "NET_BANKING_RBL_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-3da02b7d667f4a39a746d556c1f60c85",
    "bankName": "AU Small Finance Bank Corporate",
    "paymentType": "NET_BANKING_AU_SMALL_FINANCE_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-f0ca7ef171cf443991a6f04381dd4989",
    "bankName": "DBS Bank Ltd Corporate",
    "paymentType": "NET_BANKING_DBS_BANK_LTD_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-7703ac5acf004eefb2764e3b553f4b3a",
    "bankName": "Indian Bank Corporate",
    "paymentType": "NET_BANKING_INDIAN_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-ec3ff64036f6464abb47ffba97d37720",
    "bankName": "IndusInd Bank Corporate",
    "paymentType": "NET_BANKING_INDUSIND_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-a222f754a8ab4c14a289ae6415b9c450",
    "bankName": "JP Morgan Chase Bank National Association",
    "paymentType": "NET_BANKING_JP_MORGAN_CHASE_BANK_NATIONAL_ASSOCIATION",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-9eec2a8cf1604a92acc81edf3a70ac97",
    "bankName": "Kotak Mahindra Bank Corporate",
    "paymentType": "NET_BANKING_KOTAK_MAHINDRA_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-73c43253e41e4c66a7631ae188cc4efa",
    "bankName": "Standard Chartered Bank Corporate",
    "paymentType": "NET_BANKING_STANDARD_CHARTERED_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-6073ad86f9a84ea09644c440ac50ceea",
    "bankName": "IDBI Bank Corporate",
    "paymentType": "NET_BANKING_IDBI_BANK_CORPORATE",
    "category": "NET_BANKING",
    "isTest": false
  },
  {
    "gid": "swirepaynetbanking-d7c4eb8b1571409c83025f95f533d0d4",
    "bankName": "Karnataka Gramin Bank",
    "paymentType": "NET_BANKING_KARNATAKA_GRAMIN_BANK",
    "category": "NET_BANKING",
    "isTest": false
  },
];

export const QR_STATUSES = {
  SUCCEEDED: 'SUCCEEDED',
  REQUIRE_ACTION: 'REQUIRE_ACTION',
};

// Tangedco PG account's acuirer changed from IPG_COMMERCE-CONNECT to cashFree, so we support other paymentMethods too
export const TANGEDCO_PG = 'TANGEDCO ACCOUNT GID';

export const BUSINESS_TYPES = {
  US: [
    {
      key: 1,
      value: 'PRIVATE_CORPORATION',
      display: 'Private Corporation'
    },
    {
      key: 2,
      value: 'PUBLIC_CORPORATION',
      display: 'Public Corporation'
    },
    {
      key: 3,
      value: 'GOVERNMENT',
      display: 'Government'
    },
    {
      key: 4,
      value: 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP',
      display: 'Individual or sole proprietorship'
    },
    {
      key: 5,
      value: 'NONPROFIT_ORGANIZATION',
      display: 'Non profit organization'
    },
    {
      key: 6,
      value: 'PARTNERSHIP',
      display: 'Partnership'
    },
    {
      key: 7,
      value: 'LIMITED_LIABILITY_COMPANY',
      display: 'Limited liability company'
    },
  ],
  IN: [
    {
      key: 1,
      value: 'PRIVATE_LIMITED',
      display: 'Private Limited'
    },
    {
      key: 2,
      value: 'PUBLIC_LIMITED',
      display: 'Public Limited'
    },
    {
      key: 3,
      value: 'LIMITED_LIABILITY_PARTNERSHIP',
      display: 'Limited Liability Partnership'
    },
    {
      key: 4,
      value: 'PROPRIETORSHIP',
      display: 'Proprietorship'
    },
    {
      key: 5,
      value: 'NONPROFIT_ORGANIZATION',
      display: 'Non profit organization'
    }
  ]
};

export const COUNTRY_LIST = [
  {
    key: 1,
    value: 'USA',
    display: 'United States'
  },
  {
    key: 2,
    value: 'IN',
    display: 'India'
  },
];

export const BUSINESS_REPRESENTATIVES = {
  IN_REPRESENTATIVES_ONE: [
    {
      year: '',
      month: '',
      day: '',
      pan: '',
      title: '',
      firstName: '',
      lastName: '',
      kycAddressProofUrl: '',
      businessRepPanUrl: '',
      email: '',
      repPhoneNumber: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
    },
  ],
  IN_REPRESENTATIVES: [
    {
      year: '',
      month: '',
      day: '',
      pan: '',
      title: '',
      firstName: '',
      lastName: '',
      kycfileName: '',
      panfileName: '',
      kycAddressProofUrl: '',
      businessRepPanUrl: '',
      hasControl: true,
      email: '',
      repPhoneNumber: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
      repPhoneNumberCode: '+1',
    },
  ],
  US_REPRESENTATIVES: [
    {
      year: '',
      month: '',
      day: '',
      ssn: '',
      title: '',
      firstName: '',
      lastName: '',
      hasControl: false,
      governmentIdUrl: '',
      ownerShipPercentage: '',
      email: '',
      repPhoneNumber: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
    }
  ]
}

export const BANK_ACCOUNT_TYPE = [
  {
    key: 1,
    display: 'Virtual Bank Account',
    value: 'VIRTUAL_ACCOUNT'
  },
  {
    key: 2,
    display: 'Existing Bank Account',
    value: 'ISSUER_BANK'
  }
]

export const ISSUER_BANK_ACCOUNT_TYPE = [
  {
    key: 1,
    display: 'Virtual Bank Account via Plaid',
    value: 'PLAID'
  },
  {
    key: 2,
    display: 'Existing Bank Account via Manul',
    value: 'MANUAL'
  }
]

export const COUNTRIES = {
  USA: {
    id: 1,
    name: 'USA',
    PHONE_CODE: '+1',
  },
  INDIA: {
    id: 2,
    name: 'INDIA',
    PHONE_CODE: '+91',
  },
  CANADA: {
    id: 41,
    name: 'CANADA',
    PHONE_CODE: '+1',
  },
};

export const COUNTRIES_LIST = [
  {
    "name": "Afghanistan",
    "dial_code": "+93",
    "code": "AF"
  },
  {
    "name": "Aland Islands",
    "dial_code": "+358",
    "code": "AX"
  },
  {
    "name": "Albania",
    "dial_code": "+355",
    "code": "AL"
  },
  {
    "name": "Algeria",
    "dial_code": "+213",
    "code": "DZ"
  },
  {
    "name": "AmericanSamoa",
    "dial_code": "+1684",
    "code": "AS"
  },
  {
    "name": "Andorra",
    "dial_code": "+376",
    "code": "AD"
  },
  {
    "name": "Angola",
    "dial_code": "+244",
    "code": "AO"
  },
  {
    "name": "Anguilla",
    "dial_code": "+1264",
    "code": "AI"
  },
  {
    "name": "Antarctica",
    "dial_code": "+672",
    "code": "AQ"
  },
  {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "code": "AG"
  },
  {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR"
  },
  {
    "name": "Armenia",
    "dial_code": "+374",
    "code": "AM"
  },
  {
    "name": "Aruba",
    "dial_code": "+297",
    "code": "AW"
  },
  {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU"
  },
  {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT"
  },
  {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "code": "AZ"
  },
  {
    "name": "Bahamas",
    "dial_code": "+1242",
    "code": "BS"
  },
  {
    "name": "Bahrain",
    "dial_code": "+973",
    "code": "BH"
  },
  {
    "name": "Bangladesh",
    "dial_code": "+880",
    "code": "BD"
  },
  {
    "name": "Barbados",
    "dial_code": "+1246",
    "code": "BB"
  },
  {
    "name": "Belarus",
    "dial_code": "+375",
    "code": "BY"
  },
  {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE"
  },
  {
    "name": "Belize",
    "dial_code": "+501",
    "code": "BZ"
  },
  {
    "name": "Benin",
    "dial_code": "+229",
    "code": "BJ"
  },
  {
    "name": "Bermuda",
    "dial_code": "+1441",
    "code": "BM"
  },
  {
    "name": "Bhutan",
    "dial_code": "+975",
    "code": "BT"
  },
  {
    "name": "Bolivia, Plurinational State of",
    "dial_code": "+591",
    "code": "BO"
  },
  {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "code": "BA"
  },
  {
    "name": "Botswana",
    "dial_code": "+267",
    "code": "BW"
  },
  {
    "name": "Brazil",
    "dial_code": "+55",
    "code": "BR"
  },
  {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "code": "IO"
  },
  {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "code": "BN"
  },
  {
    "name": "Bulgaria",
    "dial_code": "+359",
    "code": "BG"
  },
  {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "code": "BF"
  },
  {
    "name": "Burundi",
    "dial_code": "+257",
    "code": "BI"
  },
  {
    "name": "Cambodia",
    "dial_code": "+855",
    "code": "KH"
  },
  {
    "name": "Cameroon",
    "dial_code": "+237",
    "code": "CM"
  },
  {
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA"
  },
  {
    "name": "Cape Verde",
    "dial_code": "+238",
    "code": "CV"
  },
  {
    "name": "Cayman Islands",
    "dial_code": "+ 345",
    "code": "KY"
  },
  {
    "name": "Central African Republic",
    "dial_code": "+236",
    "code": "CF"
  },
  {
    "name": "Chad",
    "dial_code": "+235",
    "code": "TD"
  },
  {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL"
  },
  {
    "name": "China",
    "dial_code": "+86",
    "code": "CN"
  },
  {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "code": "CC"
  },
  {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO"
  },
  {
    "name": "Comoros",
    "dial_code": "+269",
    "code": "KM"
  },
  {
    "name": "Congo",
    "dial_code": "+242",
    "code": "CG"
  },
  {
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "code": "CD"
  },
  {
    "name": "Cook Islands",
    "dial_code": "+682",
    "code": "CK"
  },
  {
    "name": "Costa Rica",
    "dial_code": "+506",
    "code": "CR"
  },
  {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "code": "CI"
  },
  {
    "name": "Croatia",
    "dial_code": "+385",
    "code": "HR"
  },
  {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU"
  },
  {
    "name": "Cyprus",
    "dial_code": "+357",
    "code": "CY"
  },
  {
    "name": "Czech Republic",
    "dial_code": "+420",
    "code": "CZ"
  },
  {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK"
  },
  {
    "name": "Djibouti",
    "dial_code": "+253",
    "code": "DJ"
  },
  {
    "name": "Dominica",
    "dial_code": "+1767",
    "code": "DM"
  },
  {
    "name": "Dominican Republic",
    "dial_code": "+1849",
    "code": "DO"
  },
  {
    "name": "Ecuador",
    "dial_code": "+593",
    "code": "EC"
  },
  {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG"
  },
  {
    "name": "El Salvador",
    "dial_code": "+503",
    "code": "SV"
  },
  {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "code": "GQ"
  },
  {
    "name": "Eritrea",
    "dial_code": "+291",
    "code": "ER"
  },
  {
    "name": "Estonia",
    "dial_code": "+372",
    "code": "EE"
  },
  {
    "name": "Ethiopia",
    "dial_code": "+251",
    "code": "ET"
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "code": "FK"
  },
  {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "code": "FO"
  },
  {
    "name": "Fiji",
    "dial_code": "+679",
    "code": "FJ"
  },
  {
    "name": "Finland",
    "dial_code": "+358",
    "code": "FI"
  },
  {
    "name": "France",
    "dial_code": "+33",
    "code": "FR"
  },
  {
    "name": "French Guiana",
    "dial_code": "+594",
    "code": "GF"
  },
  {
    "name": "French Polynesia",
    "dial_code": "+689",
    "code": "PF"
  },
  {
    "name": "Gabon",
    "dial_code": "+241",
    "code": "GA"
  },
  {
    "name": "Gambia",
    "dial_code": "+220",
    "code": "GM"
  },
  {
    "name": "Georgia",
    "dial_code": "+995",
    "code": "GE"
  },
  {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE"
  },
  {
    "name": "Ghana",
    "dial_code": "+233",
    "code": "GH"
  },
  {
    "name": "Gibraltar",
    "dial_code": "+350",
    "code": "GI"
  },
  {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR"
  },
  {
    "name": "Greenland",
    "dial_code": "+299",
    "code": "GL"
  },
  {
    "name": "Grenada",
    "dial_code": "+1473",
    "code": "GD"
  },
  {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "code": "GP"
  },
  {
    "name": "Guam",
    "dial_code": "+1671",
    "code": "GU"
  },
  {
    "name": "Guatemala",
    "dial_code": "+502",
    "code": "GT"
  },
  {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG"
  },
  {
    "name": "Guinea",
    "dial_code": "+224",
    "code": "GN"
  },
  {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "code": "GW"
  },
  {
    "name": "Guyana",
    "dial_code": "+595",
    "code": "GY"
  },
  {
    "name": "Haiti",
    "dial_code": "+509",
    "code": "HT"
  },
  {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "code": "VA"
  },
  {
    "name": "Honduras",
    "dial_code": "+504",
    "code": "HN"
  },
  {
    "name": "Hong Kong",
    "dial_code": "+852",
    "code": "HK"
  },
  {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU"
  },
  {
    "name": "Iceland",
    "dial_code": "+354",
    "code": "IS"
  },
  {
    "name": "India",
    "dial_code": "+91",
    "code": "IN"
  },
  {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID"
  },
  {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "code": "IR"
  },
  {
    "name": "Iraq",
    "dial_code": "+964",
    "code": "IQ"
  },
  {
    "name": "Ireland",
    "dial_code": "+353",
    "code": "IE"
  },
  {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM"
  },
  {
    "name": "Israel",
    "dial_code": "+972",
    "code": "IL"
  },
  {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT"
  },
  {
    "name": "Jamaica",
    "dial_code": "+1876",
    "code": "JM"
  },
  {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP"
  },
  {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE"
  },
  {
    "name": "Jordan",
    "dial_code": "+962",
    "code": "JO"
  },
  {
    "name": "Kazakhstan",
    "dial_code": "+77",
    "code": "KZ"
  },
  {
    "name": "Kenya",
    "dial_code": "+254",
    "code": "KE"
  },
  {
    "name": "Kiribati",
    "dial_code": "+686",
    "code": "KI"
  },
  {
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "code": "KP"
  },
  {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "code": "KR"
  },
  {
    "name": "Kuwait",
    "dial_code": "+965",
    "code": "KW"
  },
  {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "code": "KG"
  },
  {
    "name": "Laos",
    "dial_code": "+856",
    "code": "LA"
  },
  {
    "name": "Latvia",
    "dial_code": "+371",
    "code": "LV"
  },
  {
    "name": "Lebanon",
    "dial_code": "+961",
    "code": "LB"
  },
  {
    "name": "Lesotho",
    "dial_code": "+266",
    "code": "LS"
  },
  {
    "name": "Liberia",
    "dial_code": "+231",
    "code": "LR"
  },
  {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "code": "LY"
  },
  {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "code": "LI"
  },
  {
    "name": "Lithuania",
    "dial_code": "+370",
    "code": "LT"
  },
  {
    "name": "Luxembourg",
    "dial_code": "+352",
    "code": "LU"
  },
  {
    "name": "Macao",
    "dial_code": "+853",
    "code": "MO"
  },
  {
    "name": "Macedonia",
    "dial_code": "+389",
    "code": "MK"
  },
  {
    "name": "Madagascar",
    "dial_code": "+261",
    "code": "MG"
  },
  {
    "name": "Malawi",
    "dial_code": "+265",
    "code": "MW"
  },
  {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY"
  },
  {
    "name": "Maldives",
    "dial_code": "+960",
    "code": "MV"
  },
  {
    "name": "Mali",
    "dial_code": "+223",
    "code": "ML"
  },
  {
    "name": "Malta",
    "dial_code": "+356",
    "code": "MT"
  },
  {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "code": "MH"
  },
  {
    "name": "Martinique",
    "dial_code": "+596",
    "code": "MQ"
  },
  {
    "name": "Mauritania",
    "dial_code": "+222",
    "code": "MR"
  },
  {
    "name": "Mauritius",
    "dial_code": "+230",
    "code": "MU"
  },
  {
    "name": "Mayotte",
    "dial_code": "+262",
    "code": "YT"
  },
  {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX"
  },
  {
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "code": "FM"
  },
  {
    "name": "Moldova",
    "dial_code": "+373",
    "code": "MD"
  },
  {
    "name": "Monaco",
    "dial_code": "+377",
    "code": "MC"
  },
  {
    "name": "Mongolia",
    "dial_code": "+976",
    "code": "MN"
  },
  {
    "name": "Montenegro",
    "dial_code": "+382",
    "code": "ME"
  },
  {
    "name": "Montserrat",
    "dial_code": "+1664",
    "code": "MS"
  },
  {
    "name": "Morocco",
    "dial_code": "+212",
    "code": "MA"
  },
  {
    "name": "Mozambique",
    "dial_code": "+258",
    "code": "MZ"
  },
  {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM"
  },
  {
    "name": "Namibia",
    "dial_code": "+264",
    "code": "NA"
  },
  {
    "name": "Nauru",
    "dial_code": "+674",
    "code": "NR"
  },
  {
    "name": "Nepal",
    "dial_code": "+977",
    "code": "NP"
  },
  {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL"
  },
  {
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "code": "AN"
  },
  {
    "name": "New Caledonia",
    "dial_code": "+687",
    "code": "NC"
  },
  {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ"
  },
  {
    "name": "Nicaragua",
    "dial_code": "+505",
    "code": "NI"
  },
  {
    "name": "Niger",
    "dial_code": "+227",
    "code": "NE"
  },
  {
    "name": "Nigeria",
    "dial_code": "+234",
    "code": "NG"
  },
  {
    "name": "Niue",
    "dial_code": "+683",
    "code": "NU"
  },
  {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "code": "NF"
  },
  {
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "code": "MP"
  },
  {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO"
  },
  {
    "name": "Oman",
    "dial_code": "+968",
    "code": "OM"
  },
  {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK"
  },
  {
    "name": "Palau",
    "dial_code": "+680",
    "code": "PW"
  },
  {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "code": "PS"
  },
  {
    "name": "Panama",
    "dial_code": "+507",
    "code": "PA"
  },
  {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "code": "PG"
  },
  {
    "name": "Paraguay",
    "dial_code": "+595",
    "code": "PY"
  },
  {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE"
  },
  {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH"
  },
  {
    "name": "Pitcairn",
    "dial_code": "+872",
    "code": "PN"
  },
  {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL"
  },
  {
    "name": "Portugal",
    "dial_code": "+351",
    "code": "PT"
  },
  {
    "name": "Puerto Rico",
    "dial_code": "+1939",
    "code": "PR"
  },
  {
    "name": "Qatar",
    "dial_code": "+974",
    "code": "QA"
  },
  {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO"
  },
  {
    "name": "Russia",
    "dial_code": "+7",
    "code": "RU"
  },
  {
    "name": "Rwanda",
    "dial_code": "+250",
    "code": "RW"
  },
  {
    "name": "Reunion",
    "dial_code": "+262",
    "code": "RE"
  },
  {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "code": "BL"
  },
  {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "code": "SH"
  },
  {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "code": "KN"
  },
  {
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "code": "LC"
  },
  {
    "name": "Saint Martin",
    "dial_code": "+590",
    "code": "MF"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "code": "PM"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "code": "VC"
  },
  {
    "name": "Samoa",
    "dial_code": "+685",
    "code": "WS"
  },
  {
    "name": "San Marino",
    "dial_code": "+378",
    "code": "SM"
  },
  {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "code": "ST"
  },
  {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "code": "SA"
  },
  {
    "name": "Senegal",
    "dial_code": "+221",
    "code": "SN"
  },
  {
    "name": "Serbia",
    "dial_code": "+381",
    "code": "RS"
  },
  {
    "name": "Seychelles",
    "dial_code": "+248",
    "code": "SC"
  },
  {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "code": "SL"
  },
  {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG"
  },
  {
    "name": "Slovakia",
    "dial_code": "+421",
    "code": "SK"
  },
  {
    "name": "Slovenia",
    "dial_code": "+386",
    "code": "SI"
  },
  {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "code": "SB"
  },
  {
    "name": "Somalia",
    "dial_code": "+252",
    "code": "SO"
  },
  {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA"
  },
  {
    "name": "South Sudan",
    "dial_code": "+211",
    "code": "SS"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "code": "GS"
  },
  {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES"
  },
  {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK"
  },
  {
    "name": "Sudan",
    "dial_code": "+249",
    "code": "SD"
  },
  {
    "name": "Suriname",
    "dial_code": "+597",
    "code": "SR"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ"
  },
  {
    "name": "Swaziland",
    "dial_code": "+268",
    "code": "SZ"
  },
  {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE"
  },
  {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH"
  },
  {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "code": "SY"
  },
  {
    "name": "Taiwan",
    "dial_code": "+886",
    "code": "TW"
  },
  {
    "name": "Tajikistan",
    "dial_code": "+992",
    "code": "TJ"
  },
  {
    "name": "Tanzania, United Republic of Tanzania",
    "dial_code": "+255",
    "code": "TZ"
  },
  {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH"
  },
  {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "code": "TL"
  },
  {
    "name": "Togo",
    "dial_code": "+228",
    "code": "TG"
  },
  {
    "name": "Tokelau",
    "dial_code": "+690",
    "code": "TK"
  },
  {
    "name": "Tonga",
    "dial_code": "+676",
    "code": "TO"
  },
  {
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "code": "TT"
  },
  {
    "name": "Tunisia",
    "dial_code": "+216",
    "code": "TN"
  },
  {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR"
  },
  {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "code": "TM"
  },
  {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "code": "TC"
  },
  {
    "name": "Tuvalu",
    "dial_code": "+688",
    "code": "TV"
  },
  {
    "name": "Uganda",
    "dial_code": "+256",
    "code": "UG"
  },
  {
    "name": "Ukraine",
    "dial_code": "+380",
    "code": "UA"
  },
  {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "code": "AE"
  },
  {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB"
  },
  {
    "name": "United States",
    "dial_code": "+1",
    "code": "US"
  },
  {
    "name": "Uruguay",
    "dial_code": "+598",
    "code": "UY"
  },
  {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "code": "UZ"
  },
  {
    "name": "Vanuatu",
    "dial_code": "+678",
    "code": "VU"
  },
  {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "code": "VE"
  },
  {
    "name": "Vietnam",
    "dial_code": "+84",
    "code": "VN"
  },
  {
    "name": "Virgin Islands, British",
    "dial_code": "+1284",
    "code": "VG"
  },
  {
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1340",
    "code": "VI"
  },
  {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "code": "WF"
  },
  {
    "name": "Yemen",
    "dial_code": "+967",
    "code": "YE"
  },
  {
    "name": "Zambia",
    "dial_code": "+260",
    "code": "ZM"
  },
  {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "code": "ZW"
  }
]

export const LPG_CUSTOMER = [
  'IPG_COMMERCE-CONNECT'
];

export const INVOICE_LINK = {
  PAY_TERMS: 'By selecting this checkbox, you agree to the  payment terms.'
}

export const TABLET_SCREEN_WIDTH = 576;

export const US_FILING_GID = 'account-e03b48f3c3524a51a299eb3e64621651';

export const PLAID_BUSINESS_TYPES = [
  {
    label: 'INDIVIDUAL',
    value: 'INDIVIDUAL',
  },
  {
    label: 'BUSINESS',
    value: 'BUSINESS',
  },
];

export const PINCODE_PATTERNS = {
  US: /^\d{5}(-\d{4})?$/, // 12345 or 12345-6789
  CA: /^[A-Z]\d[A-Z] \d[A-Z]\d$/i, // A1B 2C3 (Standard Canadian format)
  IN: /^\d{6}$/, // 110001 (6 digits)
};

export const ALPHA2_COUNTRY_MAP = {
  US: 'USA',
  CA: 'CANADA',
  IN: 'INDIA',
};

export const PRODUCT_OPTIONS = [
  { label: 'Transfer Money', value: 'ACCOUNT_PAYABLES' },
  { label: 'Receive Money Online', value: 'ACCOUNT_RECEIVABLES_ONLINE' },
  { label: 'Receive Money via POS', value: 'ACCOUNT_RECEIVABLES_POS' },
  { label: 'Platform / Marketplace', value: 'MARKETPLACE' },
];

export const ACQUIRER_TYPE_PAYPAL = "PAYPAL";
export const ACQUIRER_TYPE_PAYPAL_BNY = "PAYPAL-BNY";
